import initialState from './initialState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = initialState();

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
